module.exports = __webpack_public_path__ + "img/mt-empty.5e56ee41.png";